import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { LoadingIndicatorDirective } from '@zero/shared/ui-directives';
import { Asset, ExanteRequest, OrderCreateData } from '@zero/shared/util-models';
import { DataService, UserMessagesHolderService } from '@zero/shared/util-web-app-services';
import { MultiOrderInstrument } from '@zero/trade/domain';
import { environment } from 'environments/environment';
import { firstValueFrom } from 'rxjs';

interface ExanteResponse {
  success: boolean;
  message: string;
  posteingangId: string;
  uri: string;
}

@Component({
  selector: 'trade-exante',
  templateUrl: './exante.component.html',
  imports: [LoadingIndicatorDirective, TranslocoPipe],
})
export class ExanteComponent implements OnInit {
  @Input() public inputData?: OrderCreateData | Asset | MultiOrderInstrument;
  @Input() public instrumentType: 'savings-plan' | 'default' = 'default';
  @Input() public isFraction = false;

  public ongoingRequest = false;
  public documentId?: string;
  public uri?: string;
  public errorMessage?: string;

  #exanteRequestData?: ExanteRequest;
  readonly #http = inject(HttpClient);
  readonly #rootDataService = inject(DataService);
  readonly #msgService = inject(UserMessagesHolderService);

  public ngOnInit() {
    this.errorMessage = undefined;
    this.documentId = undefined;
    this.ongoingRequest = false;
    this.#updateExanteRequestData();
    this.#generateExanteDocument();
  }

  async #generateExanteDocument(): Promise<void> {
    this.ongoingRequest = true;
    try {
      const url = `${environment.serverlessApihost}/apic/exante${this.isFraction ? '/fraction' : ''}`;
      const response = await firstValueFrom(this.#http.post<ExanteResponse>(url, this.#exanteRequestData));
      if (response?.success) {
        this.documentId = response.posteingangId;
        this.uri = environment.apihost + response.uri;
      } else {
        this.#setError(response.message);
      }
    } catch (err) {
      this.#setError(err?.error?.message ? err.error.message : err.message);
    } finally {
      this.ongoingRequest = false;
    }
  }

  #setError = (msg: string): void => {
    this.documentId = undefined;
    this.errorMessage = msg;
  };

  #updateExanteRequestData() {
    if (this.inputData) {
      this.#exanteRequestData = {
        isin: this.inputData.isin,
        customerId: this.#rootDataService.getSelectedCustomer(),
        sparplan: this.instrumentType === 'savings-plan',
      };
    } else {
      this.#exanteRequestData = null;
    }
  }

  public retry(): void {
    this.#msgService.clearAllMessages();
    this.ngOnInit();
  }
}
